import { SERVICE_OGP_IMAGE, SITE_URL } from '../constants'
import { PageMeta } from '../types'

export const topPageMeta: PageMeta = {
  title: 'AI駆動開発・UX/UI・デザインシステム・モダナイゼーション・内製化支援｜Aitria（アイトリア）',
  description:
    'Design × AI × Engineering で、日本のITを再起動する。Aitria（アイトリア）はAI駆動のデジタルエンジニアリング企業です。AIエージェント、モダンスタック、CI/CD、DevOps、UX/UIをフル活用した開発スタイルで、顧客のモダナイゼーションとAIシフトを実装します。',
  keyword:
    'クラウドネイティブ AI駆動開発 デザインシステム モダナイゼーション UX/UI デザイン モダンスタック AIエージェント',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/`,
}
